import { render } from "./AuctionsPage.vue?vue&type=template&id=59595400&scoped=true"
import script from "./AuctionsPage.vue?vue&type=script&lang=js"
export * from "./AuctionsPage.vue?vue&type=script&lang=js"

import "./AuctionsPage.vue?vue&type=style&index=0&id=59595400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59595400"]])

export default __exports__